import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './AboutAcmSection.css'; 

import acmLogo from '../assets/acm_logo.png';

const AboutAcmSection = () => {
    const navigate = useNavigate();

    return (
        <section className="about-acm-section">
            <motion.div 
                className="about-acm-logo-container"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
            >
                <img src={acmLogo} alt="ACM Logo" className="about-acm-logo" />
            </motion.div>
            <motion.div 
                className="about-acm-content"
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
            >
                <h2 className="about-acm-title">What is ACM?</h2>
                <p className="about-acm-description">
                    The Association for Computing Machinery (ACM) is the world's largest educational and scientific computing society, uniting educators, researchers, and professionals to inspire dialogue, share resources, and address the field's challenges.
                </p>
                <motion.button 
                    className="about-acm-button"
                    onClick={() => window.open('https://www.acm.org/about-acm', '_blank')}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Learn More About Us
                </motion.button>
            </motion.div>
        </section>
    );
};

export default AboutAcmSection;
